<style>
  .container {
    width: 100% !important;
    position: static !important;
  }

  .invoiceinput {
    border: 1px solid rgb(224, 224, 224);
    border-radius: 4px;
    padding: 5px 10px;
  }

  .bold {
    font-weight: bold;
  }

  .paddingbottom {
    padding-bottom: 15px;
  }

  .margintop {
    margin-top: 25px;
  }


  mat-icon {
    position: relative;
    top: 0;
    margin: 0 5px;
    vertical-align: middle;
    font-size: 18px;
  }

    mat-icon.info {
      font-size: 16px;
    }

  .dialogbutton {
    height: 42px;
    width: 100%;
    cursor: pointer;
  }
  /*
  .material-icons {
    font-size: 16px;
  }*/

  .mat-icon {
    height: 16px;
    width: 16px;
  }

  .fontsize80 {
    font-size: 80%;
  }

  .search {
    width: 90%;
    margin-right: 5px;
  }

  .check {
    color: green;
    margin-left: 5px;
  }

  .error {
    color: red;
    margin-left: 5px;
  }

  .net-group {
    border: 1px solid #b6b6b6;
    padding: 15px 15px 15px 15px;
    margin: 15px 0;
  }

  .error-message {
    color: red;
    font-size: 80%;
    margin-bottom: 15px;
  }

  .radioButtonMargin{
      margin-right:5px;
  }
  .amount-input
  {
      width:120px;
  }
</style>



<div class="container combined-invoice-page">
  <div class="row combined-invoice-access-denied" *ngIf="invoiceAccessDenied">
    <div class="col-md-12">
      <div style="margin-bottom: 20px; color: red; font-style: italic;">
        {{ invoiceAccessDeniedMessage }}
      </div>
    </div>
  </div>

  <ng-container *ngIf="!invoiceAccessDenied">
    <ng-container *ngIf="isInvoiceCreated() && !isLoading; else combinedInvoiceLoading">
  <div class="row combined-invoice-hero">
    <div class="col-md-12">
      <h3 class="main-heading sam-page-heading">SKAPA SAMLINGSFAKTURA <span *ngIf="invoice?.CreditInvoiceFor != null" style="color:red;">KREDITFAKTURA</span></h3>
    </div>
  </div>

  <nav class="combined-invoice-steps" aria-label="Samlingsfakturans delar">
    <a class="combined-invoice-step" href="#combined-invoice-customer-section"><span>1</span><strong>Fakturamottagare</strong></a>
    <a class="combined-invoice-step" href="#combined-invoice-billing-section"><span>2</span><strong>Fakturering</strong></a>
    <a class="combined-invoice-step" href="#combined-invoice-specification-section"><span>3</span><strong>Specifikation</strong></a>
  </nav>

  <div class="row combined-invoice-admin-tools" *ngIf="isAdmin && !isLoading && invoice.Id == 0">
    <div class="col-sm-12 col-lg-4">
      <div class="col-sm-12 col-lg-12">
        <mat-form-field floatLabel="always" style="width: 100%;" class="full-width">
  <mat-label>Hämta annan avsändare än admin</mat-label>
          <input [disabled]="isInvoiceContentLocked()" matInput [(ngModel)]="memberSearchTerm" [id]="memberSearch" [name]="memberSearch" aria-label="Medlem" (input)="filterStates(memberSearchTerm)" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="memberSelected($event)">
            <mat-option *ngFor="let state of filteredStates | async" [value]="state.MemberNumber">
              <span *ngIf="state.CompanyName != null">{{ state.CompanyName }} ({{ state.OrgNumber }})</span>
              <span *ngIf="state.CompanyName == null">{{ state.FirstName + ' ' + state.LastName}} ({{ state.EmploymentNumber }})</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-sm-12 col-lg-12" style="min-height: 48px;">
        <div style="display: block; position: relative; top: -10px;" *ngIf="selectedMemberObject != null">
          Vald avsändare:<br />
          <span *ngIf="selectedMemberObject?.CompanyName != null"><b>{{selectedMemberObject?.CompanyName}}</b> ({{selectedMemberObject?.OrgNumber}})</span>
          <span *ngIf="selectedMemberObject?.CompanyName == null"><b>{{selectedMemberObject?.FirstName + ' ' + selectedMemberObject?.LastName}}</b></span>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-lg-6">
      <button color="primary" mat-raised-button style="position: relative; top: 11px;" (click)="getNewSender(invoice)" [disabled]="!canUpdateInvoiceDraft()">Hämta avsändardata och skapa faktura</button>
    </div>
  </div>

  <div class="row align-items-end section">
    <div id="combined-invoice-customer-section" class="col-sm-12 d-flex justify-content-start invoice-section-heading">
      <span class="invoice-section-heading-icon" aria-hidden="true"><mat-icon>person_outline</mat-icon></span>
      <h2>1. Fakturamottagare</h2>
      <!--<mat-icon class="descriptionIcon" color="accent">assignment_ind</mat-icon>-->
    </div>

    <div class="col-sm-12 col-md-8 col-lg-6 select-customer"
         [class.customer-selection-empty]="!invoice?.Customer?.Id">
      <mat-card class="select-customer-card">
        <mat-card-title>Välj en kund<mat-icon color="primary" class="info-icon" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Om mottagaren är privatperson så behöver inte referens finnas med">info</mat-icon></mat-card-title>

        <!-- Select customer -->
        <!--<div class="row">
        <mat-checkbox [disabled]="!canUpdateInvoice()" label="self" *ngIf="invoice" class="col-lg-6 col-sm-6 mb-2" [(ngModel)]="userIsInvoiceReceiver" (ngModelChange)="customerChangeToUser($event)">
          Jag vill skicka fakturan till mig själv
        </mat-checkbox>
      </div>-->
        <div class="row">
          <div class="col-9">
            <mat-form-field floatLabel="always" class="customer-select-field">
              <mat-label>Ange mottagare</mat-label>
              <mat-select [disabled]="!canUpdateInvoiceDraft() || !canUpdateGeneral() || companies.length == 0"
                          name="companies"
                          [ngModel]="invoice?.Customer?.Id" (ngModelChange)="invoice && invoice.Customer ? (invoice.Customer.Id = $event) : null; customerChange($event)">
                <mat-option *ngFor="let c of companies" [value]="c.Id">
                  {{ c.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3 action-buttons">
            <button mat-stroked-button color="primary" class="customer-action"
                    (click)="addCustomer()"
                    [disabled]="!canUpdateGeneral()"
                    matTooltip="Lägg till ny kund" matTooltipPosition="before">
              <mat-icon>person_add</mat-icon>
            </button>
            <button mat-stroked-button color="primary" class="customer-action"
                    *ngIf="invoice?.Customer.Id > 0"
                    (click)="editCustomer()"
                    [disabled]="!canUpdateGeneral()"
                    matTooltip="Redigera" matTooltipPosition="before">
              <mat-icon class="edit-icon">edit</mat-icon>
            </button>
          </div>
        </div>

        <!-- Select reference person -->
        <div class="row">
          <div class="col-9">
            <mat-form-field floatLabel="always" *ngIf="invoice.Customer.IsCompany" class="customer-select-field">
              <mat-label>Din kontaktperson*</mat-label>
              <mat-select [disabled]="!canUpdateInvoiceDraft() || !canUpdateGeneral() || invoice.Customer.Contacts == null || invoice.Customer.Contacts.length == 0"
                          [ngModel]="invoice?.Reference?.Id"
                          (ngModelChange)="invoice && invoice.Reference ? (invoice.Reference.Id = $event) : null; contactChange($event)">
                <mat-option *ngFor="let c of invoice.Customer.Contacts" [value]="c.Id">
                  {{ c.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3 action-buttons">
            <button mat-stroked-button color="primary" class="customer-action"
                    *ngIf="invoice?.Customer.Id > 0"
                    (click)="addContact()"
                    [disabled]="!canUpdateGeneral()"
                    [hidden]="!invoice.Customer.IsCompany"
                    matTooltip="Lägg till ny kontakt" matTooltipPosition="before">
              <mat-icon>person_add</mat-icon>
            </button>
            <button mat-stroked-button color="primary" class="customer-action"
                    *ngIf="invoice?.Reference.Id > 0"
                    (click)="editContact(invoice.Reference)"
                    [disabled]="!canUpdateGeneral()"
                    matTooltip="Redigera" matTooltipPosition="before">
              <mat-icon class="edit-icon">edit</mat-icon>
            </button>
          </div>
        </div>

      </mat-card>
    </div>

    <div *ngIf="!invoice?.Customer?.Id" class="col-sm-12 col-md-8 col-lg-6 customer-info-placeholder">
      <mat-card class="customer-info-card" style="height: 250px; width: 100%;"></mat-card>
    </div>

    <div *ngIf="invoice?.Customer.Id > 0" class="col-sm-12 col-md-8 col-lg-6">
      <mat-card class="customer-info-card" style="height: 250px; width: 100%;">
        <div class="invoice-send-content">
          <h3>
            {{invoice?.Customer?.Name}}
            <mat-icon *ngIf="isAdmin" style="color: grey; top: 5px; height: 30px; width: 30px; font-size: 30px; float: right;" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Denna kundinfo är inte låst till fakturan">verified</mat-icon><br /><br />
          </h3>
          <div *ngIf="invoice.Customer.Co != null && invoice.Customer.Co != ''">
            c/o: {{invoice.Customer.Co}}<br />
            {{invoice.Customer.Reference}}
          </div>
          {{invoice?.Customer?.Address}}<br />
          {{invoice?.Customer?.Zip}} {{invoice?.Customer?.City}}<br />
          {{invoice?.Customer?.Country?.Name}}<br /><br />
          <span *ngIf="invoice?.Customer?.OrgNumber != ''">{{invoice?.Customer?.OrgNumber}}</span>
          <span *ngIf="invoice?.Customer?.PersonalNumber != ''">{{invoice?.Customer?.PersonalNumber}}</span>
        </div>
      </mat-card>
    </div>



    <!--Fakturarader-->
    <div id="combined-invoice-billing-section" class="col-sm-12 d-flex justify-content-start invoice-section-heading">
      <span class="invoice-section-heading-icon" aria-hidden="true"><mat-icon>send</mat-icon></span>
      <h2>2. Fakturering</h2>
      <!--<mat-icon class="descriptionIcon" color="accent">description</mat-icon>-->
    </div>

    <div class="col-sm-12">
      <mat-card class="invoice-send-card">
        <div>
          <mat-card-title class="mat-card-title" style="margin: 0 0 20px 0;">Hur vill du skicka fakturan? </mat-card-title>

          <div class="row">
            <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-lg-4">
                  <span class="bold">Fakturamärkning </span> <mat-icon color="primary" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Här skriver du en kort märkning av fakturan som kommer skrivas på själva fakturan. Detta kan vara ett ordernummer (s.k. PO-nummer), en kod som din kund önskar ha med på fakturan eller en egen märkning som t.ex. vilken månad fakturan gäller.">info</mat-icon>
                </div>
                <div class="col-lg-8">
                  <div class="invoice-marking-field">
                    <textarea class="invoiceinput" id="count" #myCounter='ngModel' rows="2"
                              maxlength="75" [disabled]="!canUpdateGeneral()" matInput *ngIf="invoice"
                              [(ngModel)]="invoice.Marking" (ngModelChange)="wordCountMarking()" placeholder="Fakturamärkning"></textarea>
                    <mat-hint>{{resultMarking}} | 75 tecken</mat-hint>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
              <div class="row" style="margin-bottom: -20px;">
                <div class="col-lg-4">
                  <span class="bold" style="position: relative; top: 18px;">Betalvillkor:</span>
                </div>
                <div class="col-lg-8">
                  <mat-form-field floatLabel="always" class="payment-term-field">
                    <mat-label>Betalvillkor</mat-label>
                    <mat-select [disabled]="!canUpdateInvoiceDraft() || !canUpdateGeneral()" [ngModel]="invoice.PaymentTerm" (ngModelChange)="invoice.PaymentTerm = $event; getDueDate();" name="paymentterm">
                      <mat-option *ngFor="let item of paymentTerms" value="{{item}}">{{item}} dagar</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <p *ngIf="canUpdateGeneral()">Beräknat förfallodatum: {{DueDate | swedishDate : 'yyyy-MM-dd'}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-lg-4">
                  <span style="position: relative; top: 18px; font-weight: bold;">Skicka via:</span>
                </div>
                <div class="col-lg-8">
                  <mat-radio-group name="invoiceSendType" [(ngModel)]="invoice.InvoiceSendType" [disabled]="!canUpdateInvoiceDraft()">
                    <!--<mat-radio-button class="ml-2" [value]="2">Post</mat-radio-button>-->
                    <mat-radio-button color="primary" class="ml-2 radioButtonMargin" [value]="1">E-post</mat-radio-button>
                    <mat-radio-button color="primary" class="ml-2 radioButtonMargin" [value]="3">E-faktura<mat-icon color="primary" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Vissa företag/organisationer kräver e-faktura, t.ex. stat, kommun och landsting. Detta är inte att förväxla med PDF-faktura via e-post. Din kund kan ge dig all nödvändig information.">info</mat-icon></mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="offset-lg-4 col-lg-8">
                  <mat-form-field floatLabel="always" color="primary" class="col-sm-12 col-lg-12 email-field" style="margin-top: 15px;" *ngIf="invoice.InvoiceSendType == 1">
                    <mat-label>Mottagarens e-postadress</mat-label>
                    <input type="email" [disabled]="!canUpdateInvoiceDraft() || !canUpdateGeneral()" matInput *ngIf="invoice" [(ngModel)]="invoice.RecieverEmail" name="email" ngModel email required />
                  </mat-form-field>
                  <mat-form-field floatLabel="always" color="primary" class="col-sm-12 col-lg-12 email-field" *ngIf="invoice.InvoiceSendType == 1" style="margin-bottom:20px;">
                    <mat-label>Fakturakopia e-postadress</mat-label>
                    <input type="email" [disabled]="!canUpdateInvoiceDraft() || !canUpdateGeneral()" matInput [(ngModel)]="invoice.RecieverEmailCopy" />
                  </mat-form-field>
                  <div style="margin-top: 15px;" *ngIf="invoice.InvoiceSendType == 3">
                    <div *ngIf="invoice.Customer.GlnNumber">
                      <span>
                        Ditt angivna GLN nummer för denna kund är: <span style="font-weight: bolder;" class="accent">{{ invoice.Customer.GlnNumber }}</span>.

                        <anms-big-input-action *ngIf="invoice?.Customer.Id > 0" icon="edit" color="primary"
                                               (action)="editCustomer()"
                                               [disabled]="!canUpdateInvoiceDraft() || !canUpdateGeneral()"
                                               matTooltip="Redigera" matTooltipPosition="before">
                        </anms-big-input-action>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="invoice.InvoiceSendType == 3">
          <div style="margin-bottom: 17px;" class="col-sm-12 col-md-8 col-lg-8">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-lg-6">
                <span class="bold">Unik fakturareferens </span> <mat-icon color="primary" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Om din kund önskar specifik referens på just denna faktura">info</mat-icon>
              </div>
              <div class="col-lg-6">
                <div class="invoice-marking-field">
                  <input class="invoiceinput"
                         type="text"
                         [disabled]="!canUpdateInvoiceDraft() || !canUpdateGeneral()"
                         matInput
                         [(ngModel)]="invoice.ReferenceText"
                         placeholder="Unik fakturareferens" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>

    <!--Specifikation-->

    <div id="combined-invoice-specification-section" class="col-sm-12 d-flex justify-content-start invoice-section-heading">
      <span class="invoice-section-heading-icon" aria-hidden="true"><mat-icon>description</mat-icon></span>
      <h2>3. Specifikation</h2>
      <!--<mat-icon class="descriptionIcon" color="accent">assignment</mat-icon>-->
    </div>
    

    <div class="col-sm-12 col-md-12">
      <mat-card class="specification-card">

        <!-- Provision -->
        <div class="row paddingbottom">
          <div class="row col-12">
            <div class="col-lg-3">
              <h4>Provision</h4>
            </div>
          </div>
          <div class="row col-12">
            <div class="col-lg-3">
              <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>Förinställd provision (procent)</mat-label>
                <input type="number" disabled matInput [ngModel]="commissionPercent" id="commission" name="commission">
              </mat-form-field>
            </div>
            <div class="col-lg-3">
              <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>Provision (procent) för denna faktura</mat-label>
                <input type="number" [disabled]="!canEditSpecification()" matInput [ngModel]="newCommissionPercent" (ngModelChange)="updateCommission($event)" id="newcommission" name="newcommission" #commission="ngModel">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <span style="font-size: 80%;">Om du tar provision/förmedlingsavgift för uppdrag du fakturerar en annan slutkund för anger du din procentsats här. Den förinställda procentsatsen kan du ändra i dina inställningar. Provisionen kommer dras från de fakturerade beloppen nedan.</span>
            </div>
          </div>
          <div class="col-lg-4 col-md-3">
          </div>
        </div>
        <!-- / Provision -->
        <!-- Global tjänstepension -->
        <div class="row paddingbottom">
          <div class="row col-12">
            <div class="col-lg-3">
              <h4>Tjänstepension</h4>
            </div>
          </div>
          <div class="row col-12">
            <div class="col-lg-3">
              <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>Pensionsavsättning (procent)</mat-label>
                <input type="number" matInput min="0" max="10" [disabled]="!canEditSpecification()" [ngModel]="globalPensionSavingsPercent" (ngModelChange)="globalPensionSavingsPercent = $event;updateGroupAmounts(globalPensionSavingsPercent, null)" id="newcommission" name="pension" #pension="ngModel">
              </mat-form-field>
            </div>
            <div class="col-lg-3">
            </div>
            <div class="col-lg-6">
              <span style="font-size: 80%;">Här kan du ange en pensionsprocent för alla samtidigt om du önskar. Du kan även redigera detta per tillagd lönemottagare. 24,26 % av summan tillkommer i skatt. Om du tar provision räknas den av först.</span>
            </div>
          </div>
          <div class="col-lg-4 col-md-3">
          </div>
        </div>
        <!-- / Global tjänstepension -->
        <!-- Delning av service-avgiften -->
        <div class="row paddingbottom">
          <div class="row col-12">
            <div class="col-lg-6">
              <h4>Delning av service-avgiften vid egenanställning</h4>
            </div>
          </div>
          <div class="row col-12">
            <div class="col-lg-3">
              <mat-checkbox class="service-fee-share-toggle" [disabled]="!canEditSpecification()" label="Använd delad serviceavgift" [(ngModel)]="invoice.ServiceFeeShare.IsActive" (ngModelChange)="updateInvoiceServiceFee()">
                Använd delad serviceavgift
              </mat-checkbox>
            </div>
            <div class="col-lg-3">
              <mat-form-field *ngIf="invoice?.ServiceFeeShare?.IsActive" style="width: 100%" floatLabel="always">
  <mat-label>Vår andel (procent)</mat-label>
                <input type="number" matInput [disabled]="!canEditSpecification()" [ngModel]="serviceFeeShare" (ngModelChange)="serviceFeeShare = $event;updateInvoiceServiceFee()" id="newcommission" name="pension" #pension="ngModel" min="0" max="100">
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <span style="font-size: 80%;">Ange här hur stor andel av service-avgiften du vill att fakturamottagaren respektive lönemottagaren ska betala om du valt egenanställd. Lönemottagaren betalar hela avgiften om inte annat anges.</span>
            </div>
          </div>
          <div class="reverse-tax-section" *ngIf="isReverseTaxAllowedForCustomer()">
            <div class="row col-12">
              <div class="col-lg-6">
                <h4>Omvänd betalningsskyldighet</h4>
              </div>
            </div>
            <div class="row col-12">
              <div class="col-lg-3">
                <mat-checkbox [disabled]="!canEditSpecification()"
                              [checked]="invoice?.ReverseTax === true"
                              (change)="onReverseTaxChange($event)">
                  Omvänd betalningsskyldighet
                </mat-checkbox>
              </div>
              <div class="col-lg-3"></div>
              <div class="col-lg-6">
                <span style="font-size: 80%;">Ange här om du vill fakturera arbeten utförda inom byggbranschen där omvänd skattskyldighet gäller.</span>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-3">
          </div>
        </div>
        <!-- / Delning av service-avgiften -->

        <div class="group-divider"></div>

        <h3>Fakturaunderlag</h3>
        <div *ngIf="saveDraftValidates()">
          <div class="row invoice-receiver-intro">
            <div class="col-sm-12 col-lg-6 invoice-receiver-copy">
              <h4>Betalmottagare</h4>
              <div>Lägg till de som ska få lön / ersättning i ditt fakturaunderlag. </div>
            </div>
            <div class="col-sm-12 col-lg-6 invoice-receiver-action">
              <button mat-raised-button color="primary" class="add-payment-receiver-button" [disabled]="isInvoiceContentLocked() || (invoice.Customer.Id == 0 || isAddingPaymentRecievers)" (click)="addPaymentRecievers($event)">Lägg till ersättningsmottagare</button>
            </div>
          </div>
        </div>


        <div class="row time-group invoice-group-card" [hidden]="invoice.InvoiceGroups.length == 0" *ngFor="let group of invoice?.InvoiceGroups" [class.group-updating]="isGroupUpdating(group)" [attr.aria-busy]="isGroupUpdating(group)" [attr.inert]="isGroupUpdating(group) ? '' : null">
          <div class="group-update-overlay" *ngIf="isGroupUpdating(group)" aria-label="Uppdaterar ersättningsmottagare">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
          <div class="invoice-group-header" (click)="toggleGroupCollapsed(group)">
            <div class="group-avatar">
              <mat-icon *ngIf="!group.PaymentReciever?.IsCompany">person</mat-icon>
              <mat-icon *ngIf="group.PaymentReciever?.IsCompany">business</mat-icon>
            </div>
            <div class="group-header-info">
              <div class="group-header-row">
                <div class="group-name-stack">
                  <div class="group-title-line">
                    <span class="group-name-text" *ngIf="!group.PaymentReciever?.IsCompany">{{group?.PaymentReciever?.FirstName + ' ' + group?.PaymentReciever?.LastName}}</span>
                    <span class="group-name-text" *ngIf="group.PaymentReciever?.IsCompany">{{group.PaymentReciever?.CompanyName}}</span>
                  </div>
                  <div class="group-title-meta">
                    <span class="group-meta-inline" *ngIf="!group?.PaymentReciever?.IsCompany">{{ group?.PaymentReciever?.PersonalNumber || '-' }}</span>
                    <span class="group-meta-inline" *ngIf="group?.PaymentReciever?.IsCompany">{{ group?.PaymentReciever?.OrgNumber || '-' }}</span>
                    <span class="group-meta-inline">{{ getEmploymentTypeDisplay(group) }}</span>
                  </div>
                </div>
                <div class="group-header-middle">
                  <div class="group-employment" *ngIf="!group?.PaymentReciever?.IsCompany" (click)="$event.stopPropagation()">
                    <mat-form-field *ngIf="!isGroupCollapsed(group)" floatLabel="always" class="invoice-select-inline group-employment-select customer-select-field">
                      <mat-label>Anställningsform</mat-label>
                      <mat-select disableRipple
                                  [disabled]="!canUpdateGeneral() || group.SalaryCalculatorApplying"
                                  [(ngModel)]="group.EmploymentType.Id"
                                  (ngModelChange)="onEmploymentTypeChange(group)"
                                  name="employmentType-{{group?.Id}}">
                        <mat-option [value]="1">Bemanning</mat-option>
                        <mat-option [value]="2">Egenanställd</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <button type="button" mat-stroked-button class="group-salary-calculator-button" [disabled]="!canUpdateGeneral() || group.SalaryCalculatorApplying" (click)="openSalaryCalculatorForGroup(group)">Lönekalkylator</button>
                    <mat-spinner *ngIf="group.SalaryCalculatorApplying" class="group-salary-calculator-spinner" diameter="18"></mat-spinner>
                  </div>
                </div>
                <div class="group-header-right">
                  <span class="group-header-total">{{ getGroupTotalAmountInclNetExpenses(group) | number: '1.0-2' }} {{invoice?.Currency?.Name}}</span>
                  <button type="button" mat-icon-button class="group-toggle-inline" [attr.aria-label]="isGroupCollapsed(group) ? 'Visa detaljer' : 'Dölj detaljer'">
                    <mat-icon>{{ isGroupCollapsed(group) ? 'expand_more' : 'expand_less' }}</mat-icon>
                  </button>
                  <button [disabled]="isInvoiceContentLocked()" type="button" mat-icon-button class="group-edit-inline" aria-label="Redigera betalmottagare" matTooltip="Redigera betalmottagare" (click)="$event.stopPropagation(); editInvoiceCalendar(group)">
                    <mat-icon class="edit-icon">edit</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!isGroupCollapsed(group)">
          <div class="group-main-row">
            <div class="group-details">
              <div class="group-description-line">
                <span class="angular-with-newlines group-description-text">{{group?.Description ? group?.Description : '-'}}</span>
              </div>
              <div class="group-description-status-row" style="font-style: italic;">Visa på faktura: {{group?.TimeReportStatus?.DisplayName || 'Ingen'}}</div>

              <span class="row time-row fontsize80" *ngFor="let i of group.InvoiceRows; let idx = index" style="width: 100%;">
                <div class="col-4">
                  <span *ngIf="i.StartDate">{{i?.StartDate | swedishDate: 'yyyy-MM-dd'}}</span>
                </div>
                <div class="col-4">
                  <span *ngIf="(i?.HoursWorked || 0) > 0 || (i?.MinutesWorked || 0) > 0">({{i?.HoursWorked || 0}} h{{(i?.MinutesWorked || 0) > 0 ? ' ' + i?.MinutesWorked + ' min' : ''}})</span>
                </div>
                <div class="col-4">
                  <i *ngIf="isPreNotifiedInvoiceRow(i)">föranmäld</i>
                </div>
                <div class="col-12" *ngIf="group?.Type?.Value == 4">
                  <span>{{group?.Amount}} kr ({{i?.Vat}} % moms)</span>
                </div>
              </span>
            </div>

            <div class="group-underlag">
              <div class="group-amount-row" *ngIf="invoice.Customer.Country.Name != 'Sverige'">
                <div class="group-amount-field">
                  <div class="group-amount-input-row">
                    <mat-form-field floatLabel="always" class="group-amount-control customer-select-field">
                      <mat-label>Belopp (ex moms)</mat-label>
                      <input type="number" matInput [disabled]="!canUpdateGeneral() || group.SalaryCalculatorApplying" [(ngModel)]="group.Amount" (ngModelChange)="onGroupAmountUpdated(group, $event)" id="amount-{{group?.Id}}" name="amount-{{group?.Id}}">
                    </mat-form-field>
                  </div>
                  <div class="group-amount-note">{{group?.Amount}} {{invoice?.Currency?.Name}} exkl moms</div>
                </div>
              </div>

              <div class="group-amount-row" *ngIf="invoice.Customer.Country.Name == 'Sverige'">
                <div class="group-amount-field">
                  <div class="group-amount-input-row">
                    <mat-form-field floatLabel="always" class="group-amount-control customer-select-field">
                      <mat-label>Belopp (ex moms)</mat-label>
                      <input type="number" matInput [disabled]="!canUpdateGeneral() || group.SalaryCalculatorApplying" [(ngModel)]="group.Amount" (ngModelChange)="onGroupAmountUpdated(group, $event)" id="amount-{{group?.Id}}" name="amount-{{group?.Id}}">
                    </mat-form-field>
                  </div>
                  <div class="group-amount-note">{{group?.Amount}} {{invoice?.Currency?.Name}} exkl moms</div>
                </div>
              </div>
            </div>
          </div>

          <div class="group-accordion">
            <mat-accordion multi>
              <mat-expansion-panel class="group-accordion-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title class="group-accordion-title">Pensionsavsättning</mat-panel-title>
                  <mat-panel-description class="group-accordion-amount" *ngIf="group?.PensionSavingsAmount > 0 || group?.PensionSavingsTotalAmount > 0">
                    {{group?.PensionSavingsAmount | number: '1.0-2'}} {{invoice?.Currency?.Name}} exkl skatt ({{group?.PensionSavingsTotalAmount | number: '1.0-2'}} {{invoice?.Currency?.Name}} inkl skatt)
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="group-pension-summary">
                  <div class="group-pension-cell">
                    <mat-form-field floatLabel="always" class="group-pension-control customer-select-field">
                      <mat-label>Procent</mat-label>
                      <input type="number" matInput min="0" max="10" [disabled]="!canUpdateGeneral()" [ngModel]="group.PensionSavingsPercent" (ngModelChange)="onGroupPensionPercentChanged(group, $event)" id="singlecommission-{{group?.Id}}" name="singlepension-{{group?.Id}}" #singlepension="ngModel">
                      <span matSuffix class="group-pension-suffix">%</span>
                    </mat-form-field>
                  </div>
                  <div class="group-pension-cell">
                    <mat-form-field floatLabel="always" class="group-pension-control customer-select-field">
                      <mat-label>Avsättning</mat-label>
                      <input matInput disabled [value]="group?.PensionSavingsAmount | number: '1.0-2'">
                      <span matSuffix class="group-pension-suffix">{{invoice?.Currency?.Name}}</span>
                    </mat-form-field>
                  </div>
                  <div class="group-pension-cell">
                    <mat-form-field floatLabel="always" class="group-pension-control customer-select-field">
                      <mat-label>Total inkl skatt</mat-label>
                      <input matInput disabled [value]="group?.PensionSavingsTotalAmount | number: '1.0-2'">
                      <span matSuffix class="group-pension-suffix">{{invoice?.Currency?.Name}}</span>
                    </mat-form-field>
                  </div>
                </div>
                <mat-radio-group class="group-pension-mode" [disabled]="!canUpdateGeneral()" [ngModel]="group.PensionAddedToInvoice === true ? 'add' : 'deduct'" (ngModelChange)="onGroupPensionInvoiceModeChanged(group, $event)" aria-label="Hur pension ska hanteras på fakturan">
                  <mat-radio-button value="deduct">Räkna av från fakturerat belopp</mat-radio-button>
                  <mat-radio-button value="add">Lägg pension på fakturerat belopp</mat-radio-button>
                </mat-radio-group>
                <div class="group-pension-note">Välj pensionsavsättning som procent av bruttolönen (max 10 %). 24,26 % av summan tillkommer i skatt.</div>
              </mat-expansion-panel>

              <mat-expansion-panel class="group-accordion-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title class="group-accordion-title">Traktamenten / milersättning</mat-panel-title>
                  <mat-panel-description class="group-accordion-amount" *ngIf="getGroupAllowanceInvoiceAmount(group) > 0">
                    {{getGroupAllowanceInvoiceAmount(group) | number: '1.0-2'}} {{invoice?.Currency?.Name}}
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="group-accordion-actions">
                  <button mat-stroked-button class="group-action-button" *ngIf="invoice.Status.TechnicalName != 'UnderReview' || invoice.Status.Id != null || invoice.Status.TechnicalName != 'Draft'" [disabled]="!canUpdateGeneral()" (click)="editAllowance(group,'addedToInvoice')">
                    Lägg till traktamente / milersättning
                  </button>
                </div>

                <div class="group-allowance-list" [hidden]="!canUpdatePayout()">
                  <div class="group-allowance-item" *ngFor="let c of group.Allowances">
                    <div class="group-allowance-header">
                      <strong>{{getAllowanceTypeName(c?.AllowanceType?.Id)}}</strong>
                      <div class="group-allowance-actions">
                        <button *ngIf="c?.Attachment?.Guid || c?.Attachment?.Url" mat-icon-button class="group-icon-button" aria-label="Visa dokument för traktamente eller milersättning" matTooltip="Visa dokument" (click)="showFile(c.Attachment)"><mat-icon>visibility</mat-icon></button>
                        <button [disabled]="isInvoiceContentLocked()" *ngIf="c?.AllowanceType?.Id == 1 || c?.AllowanceType?.Id == '1'" mat-icon-button class="group-icon-button" aria-label="Kopiera milersättning" matTooltip="Kopiera milersättning" (click)="copyMileageAllowance(group, c)"><mat-icon>content_copy</mat-icon></button>
                        <button [disabled]="isInvoiceContentLocked()" mat-icon-button class="group-icon-button" aria-label="Radera traktamente eller milersättning" (click)="deleteAllowance(group,c)"><mat-icon>delete</mat-icon></button>
                        <button [disabled]="isInvoiceContentLocked()" mat-icon-button class="group-icon-button" aria-label="Redigera traktamente eller milersättning" (click)="editAllowance(group, ' ', c)"><mat-icon>edit</mat-icon></button>
                      </div>
                    </div>
                    <div class="group-allowance-billing-state">
                      <i>{{c.AddedToInvoice ? 'Faktureras kund' : 'Faktureras ej till kund'}}</i>
                    </div>
                    <div class="group-allowance-details">
                      <div>
                        <div class="group-allowance-travel">
                          {{c.TravelDateStart | swedishDate: 'yyyy-MM-dd'}}{{c.TravelDateEnd != null ? ' – ' + (c.TravelDateEnd | swedishDate: 'yyyy-MM-dd') : ''}}{{c.CarRegistrationNumber != null ? ' · ' + c.CarRegistrationNumber : ''}}
                        </div>
                        <div>Skattefri reseersättning: {{c.Sum | number : '1.2-2'}} SEK</div>
                      </div>
                      <div class="group-allowance-customer">Faktureras kund: {{(c.AddedToInvoice ? (c.CustomReimbursementPerKm !== 0 && c.sumCustomReimbursementPerKm ? c.sumCustomReimbursementPerKm : c.Sum) : 0) | number : '1.2-2'}} SEK</div>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel class="group-accordion-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title class="group-accordion-title">Kostnader / utlägg</mat-panel-title>
                  <mat-panel-description class="group-accordion-amount" *ngIf="getGroupDeductionInvoiceAmount(group) > 0">
                    {{getGroupDeductionInvoiceAmount(group) | number: '1.0-2'}} {{invoice?.Currency?.Name}}
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="group-accordion-actions">
                  <button mat-stroked-button class="group-action-button" *ngIf="invoice.Status.TechnicalName != 'UnderReview' || invoice.Status.Id != null || invoice.Status.TechnicalName != 'Draft'" [disabled]="!canUpdateGeneral()" (click)="editDeduction(group,'addedToInvoice')">
                    Lägg till kostnad / utlägg
                  </button>
                </div>

                <div class="group-allowance-list" [hidden]="!canUpdatePayout()">
                  <div class="group-allowance-item" *ngFor="let c of group.Deductions">
                    <div class="group-allowance-header">
                      <strong>Kostnader / utlägg</strong>
                      <div class="group-allowance-actions">
                        <button *ngIf="c?.Attachment?.Guid || c?.Attachment?.Url" mat-icon-button class="group-icon-button" aria-label="Visa dokument för kostnad eller utlägg" matTooltip="Visa dokument" (click)="showFile(c.Attachment)"><mat-icon>visibility</mat-icon></button>
                        <button mat-icon-button class="group-icon-button" [disabled]="!canUpdateGeneral()" aria-label="Redigera kostnad eller utlägg" (click)="editDeduction(group, '', c)"><mat-icon>edit</mat-icon></button>
                        <button mat-icon-button class="group-icon-button" [disabled]="!canUpdateGeneral()" aria-label="Radera kostnad eller utlägg" (click)="deleteDeduction(group,c)"><mat-icon>delete</mat-icon></button>
                      </div>
                    </div>
                    <div class="group-allowance-billing-state">
                      <i>{{c.AddedToInvoice ? 'Faktureras kund' : 'Faktureras ej till kund'}}</i>
                    </div>
                    <div class="group-allowance-details">
                      <div>
                        <div *ngIf="c?.Name">{{c.Name}}</div>
                        <div>Skattefritt utlägg: {{c?.Amount | number : '1.2-2'}} SEK</div>
                        <div *ngIf="c?.AddedToInvoice">Faktureras kund: {{(c?.AgreedInvoiceAmount != null ? c?.AgreedInvoiceAmount : c?.Amount) | number : '1.2-2'}} SEK</div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>

          


          <!-- Group amounts -->
          <div class="row col-lg-12">
            <div class="col-lg-6 fontsize80" style="padding: 10px 0 0 0;" *ngIf="newCommissionPercent > 0 || invoice.PensionSavingsFactor > 0 || group.PensionSavingsAmount > 0 || newCommissionPercent > 0 || invoice.PensionSavingsFactor > 0">
              <h4>Avdrag:</h4>
              <div class="col-lg-12" *ngIf="newCommissionPercent > 0">Provision: {{group?.commissionAmount | number: '1.0-2'}}</div>
              <div class="col-lg-12">Tjänstepension (inkl 24,26 % skatt): {{group?.PensionSavingsTotalAmount | number: '1.0-2'}}</div>
              <div class="col-lg-12" *ngIf="newCommissionPercent > 0 || group.PensionSavingsTotalAmount > 0">Lönegrundande belopp (innan ev. avgifter): {{group?.partialAmount | number: '1.0-2'}}</div>
            </div>
            <div class="col-lg-6" style="padding: 10px 0 0 0;">
              <span class="error-message">{{group.errorMessagePension}}</span>
            </div>
          </div>
          <!-- / Group amounts-->

          <div *ngIf="group.Amount != null || group.totalAmountInclNetExpenses != null" class="col-lg-12" style="padding-left: 0px;">
            <span *ngIf="invoice.Customer.Country.Name != 'Sverige'" class="row-total-amount bold">Fakturerat belopp inkl nettoersättningar: {{(group.totalAmountInclNetExpenses != null ? group.totalAmountInclNetExpenses : group.Amount) | number: '1.0-2'}} {{invoice?.Currency?.Name}} (exkl. moms)</span>
            <span *ngIf="invoice.Customer.Country.Name == 'Sverige'" class="row-total-amount bold">Fakturerat belopp inkl nettoersättningar: {{(group.totalAmountInclNetExpenses != null ? group.totalAmountInclNetExpenses : group.Amount) | number: '1.0-2'}} {{invoice?.Currency?.Name}} (exkl. moms)</span>
          </div>
          </div>

        </div>

        <div class="row paddingbottom invoice-summary-row invoice-total-section">
          <div class="col">
            <div class="totals">
              <span *ngIf="hoursWorkedTotal > 0" class="total-hours">Totalt antal timmar: {{hoursWorkedTotal | number: '1.0-2'}}</span>
              <div class="total-row">
                <mat-form-field floatLabel="always" class="currency-select">
                  <mat-label>Valuta</mat-label>
                  <mat-select [disabled]="isInvoiceContentLocked()" [(ngModel)]="invoice.Currency.Id" name="selectcurrency" (selectionChange)="currencyChanged()">
                    <mat-option *ngFor="let item of currencies" value="{{item.Id}}">{{item.Name}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <span class="accent">Totalt:</span>
                <span class="total-amount">{{invoice?.TotalInvoiceAmount + invoice?.ServiceFee | number: '1.0-2'}} {{invoice?.Currency?.Name}}</span>
                <span class="total-tax-label">(ex moms)</span>
              </div>
              <div class="invoice-summary-servicefee" *ngIf="invoice?.ServiceFee > 0">
                Varav service-avgift: {{invoice?.ServiceFee}} SEK
              </div>
            </div>
          </div>
        </div>

      </mat-card>
    </div>

    <div class="col-sm-12 pt-3 mt-5 combined-invoice-message" style="margin-top:15px;">
      <mat-card class="col-sm-12 invoice-message-card">

        <mat-card-title class="invoice-message-title">
          Meddelande till SAMekonomi
        </mat-card-title>

        <div class="invoice-message-field-row">
          <mat-form-field floatLabel="always" color="primary" appearance="outline" class="col-sm-12 col-lg-10 invoice-message-field">
            <mat-label>Meddelande</mat-label>
            <textarea matInput [ngModel]="invoice?.Message" (ngModelChange)="invoice.Message = $event" rows="3" placeholder="Skriv meddelande här" id="message" name="message" md-select-on-focus></textarea>
          </mat-form-field>
          <button mat-stroked-button mat-raised-button class="col-sm-12 col-lg-2" *ngIf="(!canUpdateInvoiceDraft() && invoice.Id != 0) || invoice.Status.Name != 'Utkast'" [disabled]="invoice.Message == undefined || invoice.Message == ''" (click)="sendMessage(invoice.Message)">Skicka</button>
        </div>

        <div *ngFor="let message of invoice.Messages">
          <span>
            <i>({{message.Created | swedishDate: 'yyyy-MM-dd'}})</i>&nbsp;<b>{{message.CreatedBy}}:</b><br />
            <span class="angular-with-newlines">{{message.Text}}</span>
          </span>
        </div>
      </mat-card>
    </div>

    <!-- Provision -->
    <!--<div class="col-sm-12 d-flex justify-content-start">
    <h2 class="accent">4. Provision</h2>
    <mat-icon class="descriptionIcon" color="accent">assignment</mat-icon>
  </div>
  <div class="col-sm-12 col-md-12">
    <mat-card class="col-sm-12">
      <div class="row paddingbottom">
        <div class="row col-12">
          <div class="col-lg-3">
            <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>Förinställd provision (procent)</mat-label>
              <input type="number" disabled matInput [ngModel]="commissionPercent" id="commission" name="commission">
            </mat-form-field>
          </div>
          <div class="col-lg-3">
            <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>Provision (procent) för denna faktura</mat-label>
              <input type="number" [disabled]="!canEditSpecification()" matInput [ngModel]="newCommissionPercent" (ngModelChange)="updateCommission($event);updateGroupAmounts()" id="newcommission" name="newcommission" #commission="ngModel">
            </mat-form-field>
          </div>
          <div class="col-lg-6">
            <span style="font-size: 80%;">Om du tar provision/förmedlingsavgift för uppdrag du fakturerar en annan slutkund för anger du din procentsats här. Den förinställda procentsatsen kan du ändra i dina inställningar. Provisionen kommer dras från de fakturerade beloppen ovan.</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-3">
        </div>
      </div>
    </mat-card>
  </div>-->
    <!-- Tjänstepension -->
    <!--<div class="col-sm-12 d-flex justify-content-start">
    <h2 class="accent">5. Tjänstepension</h2>
    <mat-icon class="descriptionIcon" color="accent">assignment</mat-icon>
  </div>
  <div class="col-sm-12 col-md-12">
    <mat-card class="col-sm-12">
      <div class="row paddingbottom">
        <div class="row col-12">
          <div class="col-lg-3">
            <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>Pensionsavsättning (procent)</mat-label>
              <input type="number" matInput [disabled]="!canEditSpecification()" [ngModel]="globalPensionSavingsPercent" (ngModelChange)="pensionSavingsPercent = $event;updateGroupAmounts()" id="newcommission" name="pension" #pension="ngModel">
            </mat-form-field>
          </div>
          <div class="col-lg-3">

          </div>
          <div class="col-lg-6">
            <span style="font-size: 80%;">Ange hur stor del av det fakturerade beloppet som ska till för tjänstepension (24,26 % av summan tillkommer i skatt). Tjänstepensionen dras på summan ovan (om du tar provision räknas den av först).</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-3">
        </div>
      </div>
    </mat-card>
  </div>-->


    <div class="col-lg-9">
    </div>
  <!-- Kampanjkod -->
   <!--<mat-form-field floatLabel="always" class="col-3">
  <mat-label>Kampanjkod</mat-label>
    <input type="text" [(ngModel)]="DiscountCode" matInput disabled />
  </mat-form-field>-->

    <div class="col-lg-6"></div>
    <div class="col-lg-6 d-flex justify-content-end combined-invoice-terms" style="margin-bottom:20px;">
      <mat-checkbox [disabled]="isInvoiceContentLocked()" label="Härmed godkänner jag" *ngIf="invoice" class="col-lg-6 col-sm-6 mb-2" [(ngModel)]="invoice.termsAgreed">
        <a [href]="fileService.buildPublicDocumentUrl('GeneralTermsOfUser.pdf')" target="_blank" class="mr-2">Jag godkänner användaravtalet</a><br /> och de <a [href]="fileService.buildPublicDocumentUrl('GeneralTermsRegistration.pdf')" target="_blank">generella villkoren</a>
      </mat-checkbox>
    </div>

    <div class="col-lg-6 combined-invoice-actions-secondary">
      <button mat-flat-button color="primary" class="col-sm-6 col-lg-4" (click)="cancel()">Avbryt</button>
    </div>
    <div class="col-sm-6 buttonrow combined-invoice-actions-primary">
      <button mat-stroked-button *ngIf="invoice.Status.TechnicalName != 'Draft'" (click)="saveDraft()" [disabled]="!canUpdateInvoiceDraft()">Spara</button>
      <button mat-stroked-button *ngIf="invoice.Status.TechnicalName == 'Draft'" (click)="saveDraft()" [disabled]="!canUpdateInvoiceDraft()">Spara utkast</button>

      <button mat-flat-button class="send-invoice-button" (click)="send(invoice)"
              [disabled]="!sendValidates() || !canUpdateInvoice()"
              color="primary">
        Skicka faktura
      </button>
    </div>
    <div class="col-lg-12 combined-invoice-validation">
      <div style="float: right; color: red; font-style: italic; font-size: 80%;">{{ getSendValidationMessage() }}</div>
    </div>
  </div>
    </ng-container>
  <ng-template #combinedInvoiceLoading>
    <div class="row combined-invoice-loading">
      <div class="col-md-12 text-center text-muted py-4">
        Laddar fakturadata...
      </div>
    </div>
  </ng-template>
  </ng-container>


</div>



